import { useEffect } from 'react';
import { useAppSelector } from '../reducers';
import { experimentByTreatmentKeySelector } from '../selectors/ExperimentSelectors';
import { SSBU_0004_TREATMENT_KEY, SSBU_0004_GROUP_PARAMETER_OPTIONS } from '../constants/experimentKeys';
import useIsEligibleForFreeToStarterTouchlessFlow from '../components/interstitial/hooks/useIsEligibleForFreeToStarterTouchlessFlow';
import { getIsAcceptanceTest } from '../utils/testUtils';
import useMarketingProduct from '../components/interstitial/hooks/useMarketingProduct';
import { logExposure } from '../utils/laboratoryClient';
const useIsCheckoutUIFreeToStarterEnabled = productConfigurations => {
  var _ssbu0004Experiment$p;
  const ssbu0004Experiment = useAppSelector(state => experimentByTreatmentKeySelector(state, SSBU_0004_TREATMENT_KEY));
  const isEligibleForFreeToStarterTouchlessFlow = useIsEligibleForFreeToStarterTouchlessFlow(productConfigurations);
  const isAcceptanceTest = getIsAcceptanceTest();
  const marketingProduct = useMarketingProduct(productConfigurations);
  const isExperimentInVariation = (ssbu0004Experiment === null || ssbu0004Experiment === void 0 || (_ssbu0004Experiment$p = ssbu0004Experiment.parameters) === null || _ssbu0004Experiment$p === void 0 ? void 0 : _ssbu0004Experiment$p.group) === SSBU_0004_GROUP_PARAMETER_OPTIONS.variation;
  const isCheckoutUIFreeToStarterEnabled = isExperimentInVariation && isEligibleForFreeToStarterTouchlessFlow && !isAcceptanceTest && !marketingProduct;
  useEffect(() => {
    if (isCheckoutUIFreeToStarterEnabled) {
      logExposure(SSBU_0004_TREATMENT_KEY);
    }
  }, [isCheckoutUIFreeToStarterEnabled]);
  return isCheckoutUIFreeToStarterEnabled;
};
export default useIsCheckoutUIFreeToStarterEnabled;